import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../../features/pcr/store/pcr.actions'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../../features/user/selectors'
import { ProcedureService } from '../services/procedure.service'
import { setAuthorizationOptions } from '../store/procedure.actions'

export function* getAuthorizationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const procedureService = new ProcedureService(serviceId)
  try {
    const authorizationResponse: IOptionsResponse = yield call([
      procedureService,
      procedureService.getAuthorizationOptions,
    ])
    const { entity } = authorizationResponse
    yield put(setAuthorizationOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getResponseOptions() error: ${e}`))
  }
}

export function* getAuthorizationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAuthorizationOptions)
}
